<div class="wrapper">
	<div class="full-width-form mat-form-field mat-form-field-can-float mat-form-field-should-float">
		<mat-label class="mat-form-field-label labelText">{{ label }}</mat-label>
		<p class="infoText">{{ info }}</p>
	</div>
</div>
